//src/context/ItemContext.js

import { createContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { fetchProducts } from "../components/apiService";

const itemContext = createContext();

function ItemProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [itemsInCart, setItemsInCart] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null); //Add user state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchProducts();
        const products = response.data;
        setProducts(products);
      } catch (error) {
        console.error("Failed to fetch products", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  const addToCart = (product) => {
    if (!product || typeof product.price !== "number") {
      console.error("Invalid product or product price", product);
      return;
    }
    setCart((prevCart) => [...prevCart, product]);
    setTotalPrice((prevTotalPrice) => prevTotalPrice + product.price);
    setItemsInCart((prevItemsInCart) => prevItemsInCart + 1);
  };

  const removeFromCart = (product) => {
    if (!product || typeof product.price !== "number") {
      console.error("Invalid product or product price", product);
      return;
    }
    setCart((prevCart) => {
      const index = prevCart.findIndex((prdt) => prdt._id === product._id);
      if (index !== -1) {
        const updatedCart = [...prevCart];
        const removedProduct = updatedCart.splice(index, 1)[0];
        setTotalPrice((prevTotalPrice) =>
          Math.max(0, prevTotalPrice - removedProduct.price)
        );
        setItemsInCart((prevItemsInCart) => Math.max(0, prevItemsInCart - 1));
        return updatedCart;
      } else {
        console.log("item not found in the cart", product);
        return prevCart;
      }
    });
  };

  const clearCart = () => {
    setCart([]);
    setItemsInCart(0);
    setTotalPrice(0);
  };

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <itemContext.Provider
      value={{
        products,
        addToCart,
        removeFromCart,
        clearCart,
        itemsInCart,
        totalPrice,
        cart,
        loading,
        user, //Provide user state
        handleLogout, //Provide logout function
      }}
    >
      {children}
    </itemContext.Provider>
  );
}

export { itemContext, ItemProvider };
